document.addEventListener("DOMContentLoaded", () => {
  let subscriptionPlanSelect =
    document.querySelector(".subscription-plan") || null;
  let subscriptionPlanDropdown =
    document.querySelector(".subscription-plan-dropdown") || null;

  let subscriptionPlanButtons =
    subscriptionPlanDropdown?.querySelectorAll("button") || [];
  let subscriptionPlanTextSpan =
    subscriptionPlanSelect?.querySelector("span") || null;

  subscriptionPlanSelect?.addEventListener("click", function (e) {
    e.stopPropagation();
    subscriptionPlanDropdown.classList.toggle("hidden");
    subscriptionPlanSelect.querySelector("svg").classList.toggle("rotate-180");
  });

  document.addEventListener("click", function (e) {
    if (
      !subscriptionPlanSelect.contains(e.target) &&
      !subscriptionPlanDropdown.contains(e.target)
    ) {
      subscriptionPlanDropdown.classList.add("hidden");
      subscriptionPlanSelect
        .querySelector("svg")
        .classList.remove("rotate-180");
    }
  });

  subscriptionPlanButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const selectedId = this.value;
      const selectedText = this.textContent;
      subscriptionPlanSelect.setAttribute("data-subscription-id", selectedId);
      subscriptionPlanTextSpan.textContent = selectedText;
      subscriptionPlanDropdown.classList.add("hidden");
      subscriptionPlanSelect
        .querySelector("svg")
        .classList.remove("rotate-180");
    });
  });

  let addToCartButtons = document.querySelectorAll(".add-to-cart-button");
  addToCartButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      let planId = null;
      let productContainer = button.closest(".product");
      let selectedVariant;

      selectedVariant =
        productContainer.querySelector(".product-variant").value;

      if (productContainer.querySelector('input[type="radio"]:checked')) {
        let selectedRadio = productContainer.querySelector(
          'input[type="radio"]:checked'
        );

        if (selectedRadio.classList.contains("subscription")) {
          planId = productContainer
            .querySelector(".subscription-plan")
            .getAttribute("data-subscription-id");
        }
      }

      let qty = productContainer.querySelector("#quantityInput").value;

      addItemToCart(selectedVariant, qty, planId);
    });
  });

  function addItemToCart(variant_id, qty, selling_plan) {
    let data = {
      id: variant_id,
      quantity: qty,
      selling_plan: selling_plan,
    };

    const xhr = new XMLHttpRequest();
    xhr.open("POST", "/cart/add.js");
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    xhr.onload = function () {
      if (xhr.status === 200) {
        initCart();
        openCartMenu();
      } else {
        const errorResponse = JSON.parse(xhr.responseText);
        alert(errorResponse.message + "\r\n" + errorResponse.description);
      }
    };

    xhr.onerror = function (error) {
      console.error("An error occurred:", error);
    };

    xhr.send(JSON.stringify(data));
  }

  window.addItemToCart = addItemToCart;

  const headerCounter = document.querySelector(".open-cart-menu i");
  const storedCount = localStorage.getItem("cartItemCount");

  if (storedCount !== null) {
    headerCounter.innerHTML = storedCount;
  } else {
    headerCounter.innerHTML = "0";
  }

  async function renderCart(data) {
    const cartCount = document.getElementById("cart-count");
    cartCount.innerText = data.item_count;

    const emptyCart = document.getElementById("cart-empty");
    const cartContent = document.getElementById("cart-content");

    const headerCounter = document.querySelector(".open-cart-menu i");
    headerCounter.innerHTML = data.item_count;

    localStorage.setItem("cartItemCount", data.item_count);

    if (data.item_count === 0) {
      emptyCart.classList.remove("hidden");
      cartContent.classList.add("hidden");
    } else {
      emptyCart.classList.add("hidden");
      cartContent.classList.remove("hidden");

      const cartItems = document.getElementById("cart-items");
      cartItems.innerHTML = "";

      const cartTotalContainer = document.getElementById("cart-total");
      const { originalTotal, discountedTotal } = calculateCartTotals(data);

      const affiliateCode = document.getElementById('affiliate-discount-code');

      if (window.cartState.isAffiliate) {
        affiliateCode.classList.remove('hidden');
      }

      let totalHtml = "";

      if (originalTotal !== discountedTotal) {
        totalHtml = `
          <span class="text-lightGrey line-through">$${originalTotal}</span>
          <span>$${discountedTotal}</span>   
        `;
      } else {
        totalHtml = `
          <span>$${discountedTotal}</span>   
        `;
      }

      cartTotalContainer.innerHTML = totalHtml;

      const subTotalCount = document.getElementById("subtotal-items");
      subTotalCount.innerHTML = `(${data.item_count} items)`;

      const btnTotal = document.getElementById("btn-total");
      btnTotal.innerHTML = `$${discountedTotal}`;

      //Render items
      data.items.forEach(function (item, index) {
        let price = "";
        if (item.hasOwnProperty("selling_plan_allocation")) {
          price = `
            <div class="flex gap-x-1.5 items-center mt-0.5">
              <span class="text-sm leading-5 text-lightGrey uppercase line-through">$${(
                item.selling_plan_allocation.compare_at_price / 100
              ).toFixed(2)}</span>
              <span class="text-sm leading-5 text-deepGreen uppercase">$${(
                item.selling_plan_allocation.price / 100
              ).toFixed(2)}</span>
              <span class="text-sm leading-5 text-deepGreen py-0.5 px-1.5 uppercase bg-orange rounded-lg">${
                item.selling_plan_allocation.selling_plan.price_adjustments[0]
                  .value
              }% OFF</span>
            </div>
            <div class="text-xs leading-5 text-lightGrey">
               You save $${(
                 (item.selling_plan_allocation.compare_at_price -
                   item.selling_plan_allocation.price) /
                 100
               ).toFixed(2)}
            </div>
          `;
        } else {
          price = `<span class="text-sm leading-5 text-deepGreen uppercase">$${(
            item.price / 100
          ).toFixed(2)}</span>`;
        }

        fetchProductData(item.handle).then((productData) => {
          if (productData) {
            let subscriptionOptions = "";

            if (!item.selling_plan_allocation) {
              subscriptionOptions += `
              <optgroup label="Full Price">
                <option value="null">One time</option>
              </optgroup>`;
            }

            subscriptionOptions += `<optgroup label="Subscription Plans">`;

            productData.selling_plan_groups.forEach((group) => {
              if (group.app_id == "5859381") {
                group.selling_plans.forEach((plan) => {
                  const isSelected =
                    plan.id === item.selling_plan_allocation?.selling_plan.id
                      ? "selected"
                      : "";
                  subscriptionOptions += `<option value="${plan.id}" ${isSelected}>${plan.name}</option>`;
                });
              }
            });

            subscriptionOptions += `</optgroup>`;
            const subscriptionHTML = `
              <div class="p-5 border-t border-lightPurple">
                <div class="relative h-10 border border-deepGreen rounded-lg">
                  <select class="w-full bg-transparent appearance-none text-deepGreen px-3 h-10 leading-10 border-none outline-none subscription-select-dropdown" data-variant-id="${item.id}" data-key="${item.key}">
                    ${subscriptionOptions}
                  </select>
                  <svg class="absolute top-2 right-1 pointer-events-none" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M16.5962 10.5962L12.0001 15.1923L7.40395 10.5962" stroke="#2A312A" stroke-linecap="square"/>
                  </svg>
                </div>
              </div>
            `;

            const subscriptionContainer = document.querySelector(
              `.subscription-select[data-product-index="${index}"]`
            );
            if (subscriptionContainer) {
              subscriptionContainer.innerHTML = subscriptionHTML;

              const selectElement = subscriptionContainer.querySelector(
                ".subscription-select-dropdown"
              );
              selectElement.addEventListener("change", function () {
                const newPlanId = this.value === "null" ? null : this.value;
                const variantId = this.dataset.variantId;
                const itemKey = this.dataset.key;

                const quantityInput = document.querySelector(
                  `.validateItemNumberInput[data-key="${itemKey}"]`
                );
                const quantity = quantityInput
                  ? parseInt(quantityInput.value) || 1
                  : 1;

                changeProductFromCart(variantId, itemKey, quantity, newPlanId);
              });
            }
          }
        });

        cartItems.innerHTML += `<div class="cart-item bg-offWhite rounded-[20px] border border-lightPurple">
        <div class="p-5 flex gap-x-4">
        <img class="w-[88px] aspect-square object-cover" src="${item.image}" alt="${item.title}" />
        <div class="flex flex-col grow">
          <h4 class="text-black text-xl">${item.title}</h4>
          
            ${price}
        
         
          <div class="flex justify-between mt-4">
            <div class="flex items-center justify-between border border-lightPurle py-2 px-2 h-10 rounded-lg">
                <button class="decrementItemQuantity px-1 text-deepGreen focus:outline-none" type="button">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 12H21" stroke="#2A312A"/></svg>
                </button>
                <input type="text" data-variant-id="${item.id}" data-key="${item.key}" class="validateItemNumberInput w-12 text-base leading-none text-center bg-transparent outline-none" value="${item.quantity}" min="1">
                <button class="incrementItemQuantity px-1 text-deepGreen focus:outline-none" type="button">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 11H21" stroke="#2A312A"/><path d="M12 20L12 2" stroke="#2A312A"/></svg>
                </button>
                </div>
              <button class="icon-cart-remove" data-delete-id='${item.key}'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M2 4H3.33333H14" stroke="#808080" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.6654 4.00016V13.3335C12.6654 13.6871 12.5249 14.0263 12.2748 14.2763C12.0248 14.5264 11.6857 14.6668 11.332 14.6668H4.66536C4.31174 14.6668 3.9726 14.5264 3.72256 14.2763C3.47251 14.0263 3.33203 13.6871 3.33203 13.3335V4.00016M5.33203 4.00016V2.66683C5.33203 2.31321 5.47251 1.97407 5.72256 1.72402C5.9726 1.47397 6.31174 1.3335 6.66536 1.3335H9.33203C9.68565 1.3335 10.0248 1.47397 10.2748 1.72402C10.5249 1.97407 10.6654 2.31321 10.6654 2.66683V4.00016" stroke="#808080" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.66797 7.3335V11.3335" stroke="#808080" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.33203 7.3335V11.3335" stroke="#808080" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
            </div>
          </div>
          </div>
          <div class="subscription-select" data-product-index="${index}"></div>
        </div>`;
      });

      //Delete item functionality
      let removeButtons = document.querySelectorAll(".icon-cart-remove");
      removeButtons.forEach(function (button) {
        if (!button) return;
        button.addEventListener("click", async function (e) {
          e.preventDefault();
          const variantId = button.dataset.deleteId;

          try {
            await deleteProductFromCart(variantId);
            initCart();
          } catch (error) {
            console.error("Error deleting product:", error);
          }
        });
      });

      // QTY functionality
      document.querySelectorAll(".cart-item").forEach((block) => {
        const decrementButton = block.querySelector(".decrementItemQuantity");
        const incrementButton = block.querySelector(".incrementItemQuantity");
        const inputField = block.querySelector(".validateItemNumberInput");

        if (!decrementButton || !incrementButton || !inputField) return;

        decrementButton.addEventListener("click", () => {
          let currentValue = parseInt(inputField.value) || 0;
          if (currentValue > 1) {
            inputField.value = currentValue - 1;

            let itemKey = inputField.dataset.key;

            changeProductQuantity(itemKey, inputField.value);
          }
        });

        incrementButton.addEventListener("click", () => {
          let currentValue = parseInt(inputField.value) || 0;
          inputField.value = currentValue + 1;

          let itemKey = inputField.dataset.key;

          changeProductQuantity(itemKey, inputField.value);
        });

        inputField.addEventListener("input", () => {
          inputField.value = inputField.value.replace(/[^0-9]/g, "");
          if (inputField.value === "" || parseInt(inputField.value) < 1) {
            inputField.value = 1;
          }

          let itemKey = inputField.dataset.key;

          changeProductQuantity(itemKey, inputField.value);
        });
      });
    }
  }

  function calculateCartTotals(cartData) {
    let originalTotal = 0;
    let discountedTotal = 0;

    cartData.items.forEach((item) => {
      if (item.selling_plan_allocation) {
        originalTotal +=
          item.selling_plan_allocation.compare_at_price * item.quantity;
        discountedTotal += item.selling_plan_allocation.price * item.quantity;
      } else {
        originalTotal += item.original_line_price;
        discountedTotal += item.final_line_price;
      }
    });

    return {
      originalTotal: (originalTotal / 100).toFixed(2),
      discountedTotal: (discountedTotal / 100).toFixed(2),
    };
  }

  function fetchProductData(productHandle) {
    return fetch(window.Shopify.routes.root + `products/${productHandle}.js`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Network response was not ok: ${response.statusText}`
          );
        }
        return response.json();
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error
        );
        alert(`Error fetching product data: ${error.message}`);
        return null;
      });
  }

  function initCart() {
    fetch("/cart.js")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        window.cartData = data;
        renderCart(data);
      })
      .catch((error) => {
        console.log("Error: " + error.message);
      });
  }

  async function changeProductFromCart(
    variantId,
    itemKey,
    qty,
    sellingPlan = null
  ) {
    console.log(
      "Variant ID:",
      variantId,
      "Item Key:",
      itemKey,
      "Quantity:",
      qty,
      "Selling Plan:",
      sellingPlan
    );

    try {
      await updateProductWithSubscription(itemKey, qty, sellingPlan);

      initCart();
    } catch (error) {
      console.error("Error in changeProductFromCart:", error);
    }
  }

  function deleteProductFromCart(itemKey) {
    return new Promise((resolve, reject) => {
      const data = {
        id: itemKey,
        quantity: 0,
      };

      postAjax(
        "/cart/change.js",
        data,
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  function addProductToCart(variantId, qty) {
    return new Promise((resolve, reject) => {
      const data = {
        id: variantId,
        quantity: qty,
      };

      postAjax(
        "/cart/add.js",
        data,
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  function updateProductWithSubscription(itemKey, qty, sellingPlan) {
    return new Promise((resolve, reject) => {
      const data = {
        id: itemKey,
        quantity: qty,
        selling_plan: sellingPlan,
      };

      postAjax(
        "/cart/change.js",
        data,
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  function changeProductQuantity(itemKey, qty) {
    const data = {
      id: itemKey,
      quantity: qty,
    };

    postAjax(
      "/cart/change.js",
      data,
      (response) => {
        console.log("Quantity updated successfully:", response);
        initCart();
      },
      (error) => {
        console.error("Error updating quantity:", error);
      }
    );
  }

  function postAjax(url, data, successCallback, errorCallback) {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        const response = JSON.parse(xhr.responseText);
        if (successCallback) successCallback(response);
      } else {
        if (errorCallback) errorCallback(xhr.statusText);
      }
    };

    xhr.onerror = function () {
      if (errorCallback) errorCallback(xhr.statusText);
    };

    xhr.send(JSON.stringify(data));
  }

  const cartIconOpen = document.querySelector(".open-cart-menu");
  const cartIconClose = document.querySelector(".close-cart-menu");
  const cartMenu = document.querySelector(".cart-menu-slideout");
  const bodyCartMenu = document.body;

  const openCartMenu = () => {
    cartMenu.classList.add("active");
    bodyCartMenu.classList.add("overflow-hidden", "body-overlay");
  };

  const closeCartMenu = () => {
    cartMenu.classList.remove("active");
    bodyCartMenu.classList.remove("overflow-hidden", "body-overlay");
  };

  const handleBodyClick = (event) => {
    const isClickInsideMenu = cartMenu.contains(event.target);
    const isClickOnOpenButton = event.target.closest(".open-cart-menu");

    if (isClickOnOpenButton) {
      openCartMenu();
    } else if (!isClickInsideMenu) {
      closeCartMenu();
    }
  };

  bodyCartMenu.addEventListener("click", handleBodyClick);
  cartIconClose.addEventListener("click", (event) => {
    event.stopPropagation();
    closeCartMenu();
  });

  let current_url = location.href;
  let url = new URL(current_url);
  let viewcart = url.searchParams.get("viewcart");
  if (viewcart == "true") {
    setTimeout(function () {
      openCartMenu();
      initCart();
    }, 700);
  }

  const openCartButton = document.querySelector(".open-cart-menu");
  openCartButton.addEventListener("click", function () {
    openCartMenu();
    initCart();
  });
});

window.cartState = window.cartState || { isAffiliate: false, ready: Promise.resolve() };

window.cartState.ready = fetch("/cart.js")
  .then(r => {
    if (!r.ok) throw new Error("Network response was not ok");
    return r.json();
  })
  .then(data => {
    console.log(data);
    window.cartState.isAffiliate = (data.discount_codes || []).some(
      d => d.code === "BODIPARTNER"
    );
  })
  .catch(err => {
    console.log("Error:", err.message);
    window.cartState.isAffiliate = false;
  });

(async () => {
  await window.cartState.ready;

  const bar = document.getElementById("affiliate-bar");
  const pdpBar = document.getElementById("affiliate-pdp-bar");

  if (!bar) return;

  if (window.cartState.isAffiliate) {
    bar.classList.remove("hidden");
    pdpBar.classList.remove("hidden");
    document.getElementById('one-time')?.click();
  }
})();